import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';
import {Provider} from "react-redux";
import {persist, store} from "./redux/store/index.store";

import {BrowserRouter} from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import 'react-slideshow-image/dist/styles.css';
import {PersistGate} from 'redux-persist/integration/react'
import Loading from "./components/loading/Loading";
import LocationChangeMonitor from "./hoc/locationChangeMonitor/LocationChangeMonitor";
import {scrollToTop} from "./helper";

let elm = document.getElementById('root');
elm.setAttribute("style", 'min-height:100vh;');
const root = createRoot(elm);

// some change on production
root.render(
    <Provider store={store}>
        <LocationChangeMonitor onChange={scrollToTop}>
            <PersistGate loading={<Loading/>} persistor={persist}>
                <BrowserRouter>
                    <App/>
                </BrowserRouter>
            </PersistGate>
        </LocationChangeMonitor>
    </Provider>
);

